import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../Auth/AuthProvider'
import { deleteAccount } from '../../Api/Account'
import { routes } from '../../routes'
import { Button } from '@/Components/ui/button'
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/Components/ui/alert-dialog'

export default function DeleteAccountSection() {
  const { logout } = useAuth()
  const navigate = useNavigate()
  const [open, setOpen] = useState(false)
  const [deleting, setDeleting] = useState(false)
  const [error, setError] = useState(null)

  const handleDelete = async () => {
    if (deleting) return

    setDeleting(true)
    setError(null)
    try {
      await deleteAccount()
      try {
        await logout()
      } catch {
        // Auth user may already be gone after server-side delete
      }
      navigate(routes.home.path)
    } catch (err) {
      console.error('Failed to delete account', err)
      setError(
        err?.response?.data?.error ||
          err?.message ||
          'Could not delete account. Try again or contact support.'
      )
      setDeleting(false)
    }
  }

  return (
    <section className="space-y-4 py-8">
      <div>
        <h2 className="text-lg font-semibold text-red-800">Danger zone</h2>
        <p className="mt-1 text-sm text-mauve-600">
          Permanently delete your account, selection requests, and related data.
          This cannot be undone.
        </p>
      </div>

      <Button type="button" variant="destructive" onClick={() => setOpen(true)}>
        Delete account
      </Button>

      <AlertDialog
        open={open}
        onOpenChange={(next) => {
          if (deleting) return
          setOpen(next)
          if (!next) setError(null)
        }}
      >
        <AlertDialogContent size="default">
          <AlertDialogHeader>
            <AlertDialogTitle>Delete your account?</AlertDialogTitle>
            <AlertDialogDescription>
              This permanently removes your FaveBack account and all of your
              requests. You will be signed out immediately.
            </AlertDialogDescription>
          </AlertDialogHeader>

          {error ? <p className="text-sm text-red-600">{error}</p> : null}

          <AlertDialogFooter>
            <AlertDialogCancel disabled={deleting}>Cancel</AlertDialogCancel>
            <AlertDialogAction
              variant="destructive"
              disabled={deleting}
              onClick={(event) => {
                event.preventDefault()
                handleDelete()
              }}
            >
              {deleting ? 'Deleting…' : 'Delete permanently'}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </section>
  )
}
